import React, { useLayoutEffect, useRef, useState } from "react";

import styled from "styled-components";

interface AnimateHeightProps {
  children: React.ReactNode;
  duration?: number; // ms
}

export const AnimateHeight: React.FC<AnimateHeightProps> = ({
  children,
  duration = 300,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<null | number>(null);

  useLayoutEffect(() => {
    if (ref.current) {
      setHeight(ref.current.scrollHeight);
    }
  }, [children]);

  return (
    <Layout duration={duration} height={height}>
      <div ref={ref}>{children}</div>
    </Layout>
  );
};

const Layout = styled.div<{ duration: number; height: number | null }>`
  height: ${(props) => (props.height !== null ? `${props.height}px` : "auto")};
  overflow: hidden;
  transition: height ${(props) => props.duration}ms ease-in-out;
`;
